<template lang="pug">
#bloco-analise-conformidade-codigo-florestal
    h2 Análise de conformidade com Código Florestal Brasileiro

    .bloco-analise
        .bloco-analise--esquerdo
            el-card.box-card
                h3 Cobertura do solo
                .margin-bloco
                    h4 Área total de Remanescentes de Vegetação Nativa
                    span 1.284,92 ha

                .margin-bloco
                    h4 Área total de Servidão Administrativa
                    span -

                div
                    h4 Área total de Uso Consolidado
                    span -

                el-divider

                h3 Reserva Legal

                .margin-bloco
                    h4 Situação da reserva legal:
                    span Não analisada

                .margin-bloco
                    h4 Área de Reserva Legal Averbada vetorizada
                    span 1.028,03 ha

                .margin-bloco
                    h4 Área de Reserva Legal Aprovada não averbada vetorizada
                    span -

                .margin-bloco
                    h4 Área de Reserva Legal Proposta vetorizada
                    span -

                div
                    h4 Total de Reserva Legal declarada pela pessoa
                    span 1.028,03 ha

        .bloco-analise--direito
            el-card.box-card
                h3 Área de Preservação Permanente

                .margin-bloco
                    h4 Áreas de Preservação Permanente
                    span 104,30 ha

                .margin-bloco
                    h4 Áreas de Preservação Permanente em área de Remanescente em Vegetação Nativa
                    span 104,30 ha

                div
                    h4 Áreas de Preservação Permanente em área consolidada
                    span 104,30 ha

                el-divider

                h3 Área de Preservação Permanente

                .margin-bloco
                    span Nenhuma restrição encontrada

                el-divider

                h3 Uso restrito

                .margin-bloco
                    h4 Áreas de Uso Restrito
                    span -
</template>

<script>
export default {
    name: 'BlocoAnaliseConformidadeCodigoFlorestal',
    data() {
        return {};
    }
};
</script>

<style lang="scss">
#bloco-analise-conformidade-codigo-florestal {
    h2 {
        font-weight: 600;
        margin-top: 30px;
        margin-bottom: 12px;
        color: #3b3b3b;
        font-size: 16px;
    }
    .bloco-analise {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        .bloco-analise--esquerdo,
        .bloco-analise--direito {
            width: 50%;
        }
        h3 {
            font-size: 16px;
            color: #3b3b3b;
            font-weight: 600;
            margin-bottom: 23px;
        }
        h4 {
            font-size: 14px;
            color: #3b3b3b;
            font-weight: 400;
            margin-bottom: 4px;
        }
        span {
            font-size: 14px;
            color: var(--primary);
            font-weight: 600;
        }
    }
    .margin-bloco {
        margin-bottom: 18px;
    }
    .el-card__body {
        min-height: 617px;
    }
}
</style>
